import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import Requests from './pages/Requests';
import Conversions from './pages/Conversions';
import Domains from './pages/Domains';
import Navbar from './components/Navbar';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        navigate('/login');
        return;
      }

      setIsAuthenticated(true);
    };

    checkAuth();
  }, [navigate]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : null;
};

function AppContent() {
  const [refreshKey, setRefreshKey] = useState(0);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const handleRefresh = () => {
    setRefreshKey(prevKey => prevKey + 1);
  };

  return (
    <div className="app-container">
      <Routes>
        <Route path="/login" element={<Login setIsLoggedIn={() => { navigate('/'); }} />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navbar onLogout={handleLogout} onRefresh={handleRefresh} />
              <Requests refreshKey={refreshKey} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/conversions"
          element={
            <ProtectedRoute>
              <Navbar onLogout={handleLogout} onRefresh={handleRefresh} />
              <Conversions refreshKey={refreshKey} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/domains"
          element={
            <ProtectedRoute>
              <Navbar onLogout={handleLogout} onRefresh={handleRefresh} />
              <Domains refreshKey={refreshKey} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}